(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./color"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./color"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.color);
    global.index = mod.exports;
  }
})(this, function (exports, _color) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _color2 = _interopRequireDefault(_color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _color2.default;
});